class SimilarInStockListings extends HTMLElement {
  connectedCallback() {
    const grid = this.querySelector('[data-similar-listings-grid]');
    if (!grid) return;

    if (grid.children.length > 0) {
      return;
    }

    this.loadFallbackListings(grid);
  }

  async loadFallbackListings(grid) {
    const productId = this.dataset.productId;
    const reference = this.dataset.reference;
    const model = this.dataset.model;
    const limit = Number(this.dataset.limit || 3);
    const root = window.Shopify?.routes?.root || '/';

    const queries = [];
    if (reference) {
      queries.push({ q: reference, matchType: 'reference', matchValue: reference });
    }
    if (model) {
      queries.push({ q: model, matchType: 'model', matchValue: model });
    }

    for (const query of queries) {
      const params = new URLSearchParams({
        q: query.q,
        type: 'product',
        view: 'similar-in-stock',
        exclude_id: productId,
        match_type: query.matchType,
        match_value: query.matchValue,
        limit: String(limit),
      });

      try {
        const response = await fetch(`${root}search?${params.toString()}`);
        if (!response.ok) continue;

        const html = await response.text();
        if (!html.trim()) continue;

        grid.innerHTML = html;
        return;
      } catch (error) {
        console.warn('Similar in-stock listings fallback failed', error);
      }
    }
  }
}

if (!customElements.get('similar-in-stock-listings')) {
  customElements.define('similar-in-stock-listings', SimilarInStockListings);
}
